import React, { useState, useRef, Children } from 'react';
import { Share } from '@capacitor/share';
import { Clipboard } from '@capacitor/clipboard';
import ShareProductButtonStyled from './bundle.esm2.js';
import { getItemPositioning } from '../../utils/bundle.esm3.js';
import Clickable from '../Clickable/bundle.esm.js';
import { defaultObject } from '../../utils/bundle.esm2.js';
import ShareSVG from '../../assets/images/bundle.esm6.js';

const ShareButton = (props) => {
  const { children, className, config } = props;
  const { onCancel, onSuccess, onError, onNotSupported } = props;
  const { tooltip = defaultObject } = props;
  const { successMessage = "Copied to the clipboard!", errorMessage } = tooltip;
  const { className: tooltipClassName = "", position = "top-center" } = tooltip;
  const { time = 1e3 } = tooltip;
  const [showTooltip, setShowTooltip] = useState(false);
  const timeoutRef = useRef();
  const handleClick = async () => {
    try {
      await Share.share(config);
      onSuccess == null ? void 0 : onSuccess();
    } catch (e) {
      if (e.message === "Share canceled") {
        onCancel == null ? void 0 : onCancel(config.url);
        return;
      }
      notSupportedHandler(config.url);
    }
  };
  const showTooltipHandler = () => {
    setShowTooltip(true);
    const tooltipTimeout = setTimeout(() => {
      hideTooltipHandler();
    }, time);
    timeoutRef.current = tooltipTimeout;
  };
  const hideTooltipHandler = () => {
    setShowTooltip(false);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };
  const notSupportedHandler = async (url) => {
    try {
      await Clipboard.write({
        url
      });
      showTooltipHandler();
      onNotSupported == null ? void 0 : onNotSupported();
    } catch (e) {
      onError == null ? void 0 : onError("Browser does not support the share API or clipboard API");
      if (!errorMessage)
        return;
      showTooltipHandler();
    }
  };
  if (Children.count(children) > 1) {
    console.error("You must provide only one children element");
    return null;
  }
  return /* @__PURE__ */ React.createElement(ShareProductButtonStyled, {
    className: `ShareButton ${className}`,
    position: getItemPositioning("top-right", position)
  }, /* @__PURE__ */ React.createElement(Clickable, {
    onClick: handleClick
  }, children != null ? children : /* @__PURE__ */ React.createElement(ShareSVG, null)), showTooltip ? /* @__PURE__ */ React.createElement("span", {
    className: `ShareButton__tooltip ${tooltipClassName}`
  }, successMessage) : null);
};
ShareButton.defaultProps = {
  className: "",
  tooltip: {
    successMessage: "Copied to the clipboard!",
    className: "",
    position: "top-center",
    errorMessage: void 0,
    time: 1e3
  }
};

export { ShareButton as default };
//# sourceMappingURL=bundle.esm.js.map
